export default __webpack_public_path__ + "static/media/yogurt.29aadf91.png";